import React, { useCallback, useContext, useEffect, useState } from 'react'
import { AlertContext } from '../../contexts/AlertContext';
import { SocketContext } from '../../contexts/SocketContext';
import { LoaderContext } from '../../contexts/LoaderContext';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';

export const useOptionsAnswer = () => {

    const [optionsAnswer, setOptionsAnswer] = useState([]);

    const { alertRef } = useContext(AlertContext);
    const { socket } = useContext(SocketContext);
    const { setOpenLoader } = useContext(LoaderContext);

    useEffect(() => {
        let subscribed = true;
        
        subscribed && getAnswers();

        return () => subscribed = false;
    }, []);

    const getAnswers = useCallback(() => {
        setOpenLoader(true);
        socket.emit('frontend:obtener-opcionesRespuesta', (response) => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current?.handleOpen('error', message);
                return;
            }

            const newArr = data?.map(generatePayload);
            setOptionsAnswer(newArr);

            setOpenLoader(false);
        });
    }, []);

    const generatePayload = (data) => ({
        ...data,
        nombre: convertirLetraMayus(data?.nombre),
        estado: data?.activo ? 'Activo' : 'Inactivo',
    });

    return {
        optionsAnswer
    }
}